import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a3dae82e8c98f6d26814f94b744b19e90b from "./generated-a8b8a72d-8047-4718-89a6-0d0c7153ba08.json";

import a1c68d9eecb30cb6143b8fcc40f4e4983b from "./generated-87f3f110-db92-4b16-b7dd-a57dc65b8d14.json";

import a45c95023cab530a8e305a1323f76e8a5b from "./generated-2dc29acb-acab-4fce-b91d-475a4114c552.json";

import abcd37696d965a3bd038c275ea4c0068db from "./generated-abac4b6d-f788-4f82-8efb-5e8a71d36b21.json";

import a6ccfd5fd688450a58dfc72262f6c4041b from "./generated-6e26029f-9a34-4df8-b148-9b0518a77145.json";

import a3ab5fc59eaa670a26543fcce03ff34bbb from "./generated-fe4578fd-83fe-4506-8386-3eead8e7e42b.json";

import afb08944ba78fbc8cddfc682dbabce383b from "./generated-564eed95-1776-48f2-b360-b23d1b114554.json";

import af75a24114a01fdaf11a410e6b3b6a298b from "./generated-6bbfac94-8dc3-4d66-86e4-c506c154471f.json";

import a2f2f7cd69d376ed7cdf688f528e6954cb from "./generated-5be21188-3243-4632-a148-986cd4d66249.json";

import a021f9df647d2f0f944bc3b6b223e0320b from "./generated-3d8ea2e2-11c6-4495-bc9c-c653273c01e3.json";

import aadaff529090efddaabd062d244a03c00b from "./generated-14210462-1955-4c28-978f-214bd705cea3.json";

import a9b7292f8bd79a125a02ce674b721dcb7b from "./generated-02cab153-5078-40c3-8d61-b3b6408e83f9.json";

import a37de9e2aa83e9cbb743495d39c3918b9b from "./generated-b4c7a4cc-98de-4594-8efc-c89ca66018bc.json";

import ae0ac8886644836aae8b7633f87d18c72b from "./generated-210823b4-0cb0-429f-b37b-561af0e3f578.json";

import aebc06dada4f433734ec5c542f30d657db from "./generated-8a4fc8a3-ec0c-415f-8a40-6d0404f33a22.json";

import a78cbc3d3f13fd41badd040fa1d62eba1b from "./generated-9aea8ff9-2b08-4e30-a9e6-08ae922b7ddd.json";

import a43af7af617bbd5de599df993436091adb from "./generated-1672a212-2e2e-40f0-a1b1-57a7667895aa.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a3dae82e8c98f6d26814f94b744b19e90b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a1c68d9eecb30cb6143b8fcc40f4e4983b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a45c95023cab530a8e305a1323f76e8a5b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(abcd37696d965a3bd038c275ea4c0068db);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a6ccfd5fd688450a58dfc72262f6c4041b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a3ab5fc59eaa670a26543fcce03ff34bbb);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(afb08944ba78fbc8cddfc682dbabce383b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(af75a24114a01fdaf11a410e6b3b6a298b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a2f2f7cd69d376ed7cdf688f528e6954cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a021f9df647d2f0f944bc3b6b223e0320b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(aadaff529090efddaabd062d244a03c00b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a9b7292f8bd79a125a02ce674b721dcb7b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a2f2f7cd69d376ed7cdf688f528e6954cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a37de9e2aa83e9cbb743495d39c3918b9b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(ae0ac8886644836aae8b7633f87d18c72b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a2f2f7cd69d376ed7cdf688f528e6954cb);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(aebc06dada4f433734ec5c542f30d657db);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a78cbc3d3f13fd41badd040fa1d62eba1b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a43af7af617bbd5de599df993436091adb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(aebc06dada4f433734ec5c542f30d657db);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */